"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUsageTracker = exports.getBeforeUnloadUsageTracker = exports.getUsageTracker = exports.getTrackerConfig = void 0;

var _events = _interopRequireDefault(require("../../events.yaml"));

var _params = require("./params");

var getSessionUrlParams = function getSessionUrlParams() {
  var trackingParams = (0, _params.getParsedTrackingParams)();
  return Object.keys(trackingParams).reduce(function (final, key) {
    var value = trackingParams[key];
    final.push(key + "=" + value);
    return final;
  }, []);
};

var getTrackerConfig = function getTrackerConfig() {
  var inAppOrPublic = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'in-app';
  return {
    events: _events.default,
    properties: {
      namespace: 'marketplace',
      type: 'integration',
      inAppOrPublic: inAppOrPublic,
      sessionUrlParams: getSessionUrlParams()
    },
    lastKnownEventProperties: ['screen']
  };
};

exports.getTrackerConfig = getTrackerConfig;
var tracker;
var beforeUnloadTracker;

var getUsageTracker = function getUsageTracker() {
  return tracker;
};

exports.getUsageTracker = getUsageTracker;

var getBeforeUnloadUsageTracker = function getBeforeUnloadUsageTracker() {
  return beforeUnloadTracker;
};

exports.getBeforeUnloadUsageTracker = getBeforeUnloadUsageTracker;

var setUsageTracker = function setUsageTracker(_tracker) {
  tracker = _tracker;
  beforeUnloadTracker = _tracker.clone({
    isBeforeUnload: true
  });
};

exports.setUsageTracker = setUsageTracker;


//////////////////
// WEBPACK FOOTER
// ./js/utils/usageTracker.js
// module id = 101
// module chunks = 209 210 211 212